import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  PdfViewerComponent, Toolbar, Magnification, Navigation, LinkAnnotation, BookmarkView,
  ThumbnailView, Print, TextSelection, Annotation, TextSearch, FormFields, FormDesigner, Inject,
  AnnotationToolbarSettings
} from '@syncfusion/ej2-react-pdfviewer';
import { registerLicense, L10n } from '@syncfusion/ej2-base';

L10n.load({
  "en-ES": {
    PdfViewer: {
      "Download": "Save",
      "DownloadOption": "Save"
    }

  }
})

registerLicense("Ngo9BigBOggjHTQxAR8/V1NMaF1cWWhKYVtpR2Nbek52flZOalxSVAciSV9jS3tTdEVlWXhbeXdSRGlVVA==")


export function App() {
  // const [filePath, setFilePath] = useState("https://www.churchofengland.org/sites/default/files/2025-02/business-done-14-february-2025-morning.pdf");
  const [filePath, setFilePath] = useState();
  // const [filePath, setFilePath] = useState("https://pdfeditor-syncfusion.pocketappserver.net/assets/business-done-14-february-2025-morning.pdf");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const file = params.get("pdfpath")
    console.log(params)

    if(file && file.length > 0 && false){
      LoadDocument(file)
    }else {
      setFilePath("https://pdfeditor-syncfusion.pocketappserver.net/assets/business-done-14-february-2025-morning.pdf")
    }
  }, []);


  function LoadDocument(file) {
    var viewer = filePath;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', file, true);
    xhr.responseType = "arraybuffer";
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var blob = new Blob([xhr.response], { type: 'application/pdf' });
        var reader = new FileReader();
        reader.onload = function () {
          var base64String = reader.result;
          viewer.load(base64String);

          debugger
          setFilePath(base64String)
        };
        reader.readAsDataURL(blob);


      }
    };
    xhr.send();
  }


  return (<div>
    <div>{filePath}</div>
    <div className='control-section'>
      {
        filePath && 
      
      <PdfViewerComponent
        id="container"
        documentPath={filePath}

        resourceUrl="https://cdn.syncfusion.com/ej2/26.2.11/dist/ej2-pdfviewer-lib"
        style={{ "height": "100vh" }}
        locale="en-ES"
        toolbarSettings={{
          showTooltip: false,
          toolbarItems: [
            // "OpenOption",
            "UndoRedoTool",
            // "PageNavigationTool",
            "MagnificationTool",
            // "PanTool",
            "SelectionTool",
            // "CommentTool",
            // "SubmitForm",
            "AnnotationEditTool",
            // "FormDesignerEditTool",
            // "FreeTextAnnotationOption",
            // "InkAnnotationOption",
            // "ShapeAnnotationOption",
            // "StampAnnotation",
            // "SignatureOption",
            "SearchOption",
            // "PrintOption",
            "DownloadOption"
          ],
          annotationToolbarItems: [
            "HighlightTool",
            "UnderlineTool",
            "StrikethroughTool",
            // "ColorEditTool",
            // "OpacityEditTool",
            "AnnotationDeleteTool",
            // "StampAnnotationTool",
            // "HandWrittenSignatureTool",
            // "InkAnnotationTool",
            // "ShapeTool",
            // "CalibrateTool",
            // "StrokeColorEditTool",
            // "ThicknessEditTool",
            // "FreeTextAnnotationTool",
            // "FontFamilyAnnotationTool",
            // "FontSizeAnnotationTool",
            // "FontStylesAnnotationTool",
            // "FontAlignAnnotationTool",
            // "FontColorAnnotationTool",
            "CommentPanelTool"
          ],
        }}
      >
        <Inject services={[
          Toolbar,
          Magnification,
          Navigation,
          Annotation,
          // LinkAnnotation,
          BookmarkView,
          ThumbnailView,
          // Print,
          TextSelection,
          // TextSearch,
          // FormFields,
          // FormDesigner
        ]} />
      </PdfViewerComponent>
      }
    </div>
  </div>);
}
const rootElement = document.getElementById('sample')!;
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);